import { axios, storage } from '../libraries'
// endpoint dev http://104.248.149.236/qwerty/forum/service/gateway/public/
// endpoint prod https://fevcippu.com/pehjGSZ/QtKOwrD/api/
// "homepage": "https://fevcippu.com",
// "homepage": "http://104.248.149.236/qwerty/forum/frontnend",
export const api = axios.create({
  baseURL: 'http://fevci.id/pehjGSZ/QtKOwrD/api/',
  headers: {
    'app-token': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2ODk5MjYzMDQsImRhdGEiOnsiaWQiOjEsImNvbXBhbnlfbmFtZSI6ImZldmNpIiwiZnVsbF9uYW1lIjoiRm9yZCBFdmVyZXN0IENMdWIgSW5kb25lc2lhIiwibG9nbyI6IlVwbG9hZGVkRmlsZVwvTG9nb0NvbXBhbnlcLzE2MzI5OTEwNTNfY29tcGFueS5wbmciLCJiYWNrZ3JvdW5kIjoiVXBsb2FkZWRGaWxlXC9BYm91dENvbXBhbnlcLzE1ODUyMTc0MjRfaWNfbG9nby5wbmciLCJoaXN0b3J5IjoibG9yZW0gaXBzdW0gZG9sb3Igc2l0IGFtZXQgcHJhbXVrYSBpcyBjb2NvbnV0In19.tYhc5rUjr1jmCFCzy6LuJMnNzyjZMOX6PoS7dlhsmWA',
    'content-type': 'application/merge-patch+json'
  }
})

api.defaults.headers.common['app-token'] = JSON.parse(storage.getItem('app-token'))
api.defaults.headers.common['Authorization'] = JSON.parse(storage.getItem('token'))

api.interceptors.request.use(request => {
  // console.log(request)
  return request
}, error => {
  console.log(error)
  return Promise.reject(error)
})

api.interceptors.response.use(response => {
  // console.log(response)
  return response
}, error => {
  // console.log(error)
  return Promise.reject(error)
})
